(function($R)
{
    $R.lang['en'] = {
        "format": "Oblikovanje",
        "image": "Slika",
        "file": "Datoteka",
        "link": "Poveznica",
        "bold": "Podebljano",
        "italic": "Kurziv",
        "deleted": "Precrtano",
        "underline": "Podcrtano",
        "superscript": "Eksponent",
        "subscript": "Indeks",
        "bold-abbr": "P",
        "italic-abbr": "K",
        "deleted-abbr": "Pr",
        "underline-abbr": "Po",
        "superscript-abbr": "Eks",
        "subscript-abbr": "Ind",
        "lists": "Liste",
        "link-insert": "Umetni poveznicu",
        "link-edit": "Uredi poveznicu",
        "link-in-new-tab": "Otvori poveznicu u novoj kartici",
        "unlink": "Ukloni poveznicu",
        "cancel": "Odustani",
        "close": "Zatvori",
        "insert": "Umetni",
        "save": "Spremi",
        "delete": "Obriši",
        "text": "Tekst",
        "edit": "Uredi",
        "title": "Naslov",
        "paragraph": "Obični tekst",
        "quote": "Citat",
        "code": "Kod",
        "heading1": "Naslov 1",
        "heading2": "Naslov 2",
        "heading3": "Naslov 3",
        "heading4": "Naslov 4",
        "heading5": "Naslov 5",
        "heading6": "Naslov 6",
        "filename": "Naziv",
        "optional": "opcionalno",
        "unorderedlist": "Lista s oznakama",
        "orderedlist": "Numerirana lista",
        "outdent": "Izvučenost",
        "indent": "Uvučenost",
        "horizontalrule": "Redak",
        "upload": "Učitaj",
        "upload-label": "Povuci datoteke ovdje ili klikni za učitavanje",
        "upload-change-label": "Povuci ovdje novu sliku kako bi se promijenila",
        "accessibility-help-label": "Rich text uređivanje",
        "caption": "Natpis",
        "bulletslist": "Natuknice",
        "numberslist": "Brojevi",
        "image-position": "Pozicija",
        "none": "Nijedno",
        "left": "Lijevo",
        "right": "Desno",
        "center": "Sredina",
        "undo": "Poništi korak",
        "redo": "Ponovi korak"
    };
})(Redactor);